
import Chart from 'chart.js/auto';
import ChartPluginZoom from 'chartjs-plugin-zoom';
import 'chartjs-adapter-moment';
import { stringToDate, dateToString, formatPrice, isMobileRes } from '../../../utils/Utils';

const MAX_VISIBLE_BARS = 20;
const MAX_TICKS_LIMIT_Y = isMobileRes() ? 5 : 8;
const STEP_SIZE_Y = 50;

class BillboardDetailPriceChart{
    constructor(){
        this.main = document.getElementById('billboard_detail_price_chart');

        this._canvas = this.main.querySelector('canvas').getContext('2d');
        
        this._chart = null;

        this._isMobileRes = isMobileRes();

        this._rootStyle = getComputedStyle(document.documentElement);
        this._primaryColor = this._rootStyle.getPropertyValue('--primary');
        this._fontFamilyBase = this._rootStyle.getPropertyValue('--font-family-base');
        
        Chart.register(ChartPluginZoom);
        
        Chart.defaults.font.family = this._fontFamilyBase;
        
        /* Chart.Tooltip.positioners.cursor = function(chartElements, coordinates) {
            return coordinates;
        }; */
        
        window.addEventListener('resize', this._onResize.bind(this));
    }

    set(dateRange, data, avgPrice){
        
        if(this._chart != null){
            this._chart.destroy();
        }
                
        let fromDate = dateRange.from;
        let toDate = dateRange.to;

        let chartdates_available = [];
        let chartDatesUnavailable = [];

        let chartMaxPrice = 0;

        for(let date = new Date(fromDate.getTime()); date <= toDate; date.setDate(date.getDate() + 1)){
            let dateStr = dateToString(date);
            let currentDate = stringToDate(dateStr);
            
            if(data.length > 0 && data[0].date == dateStr){
                let item = data.shift(); 
                chartdates_available.push({x: currentDate, y:item.price});

                if (chartMaxPrice < item.price) {
                    chartMaxPrice = item.price;
                }
            }else{
                chartDatesUnavailable.push({x: currentDate, y: avgPrice});
            }
        }

        
        let numberDates = chartdates_available.length + chartDatesUnavailable.length;
        
        let tickVisibleMaxDate = null;
        
        if(numberDates >= MAX_VISIBLE_BARS){
            tickVisibleMaxDate = new Date(fromDate.getTime());
            tickVisibleMaxDate.setDate(fromDate.getDate() + MAX_VISIBLE_BARS);     
        }

        this._chart = new Chart(this._canvas, {
            type: 'bar',
            data: {
                datasets: [
                    {
                        label: 'Days available',
                        data: chartdates_available,
                        fill: false,
                        backgroundColor: this._primaryColor

                    },
                    {
                        label: 'Days Unavailable',
                        data: chartDatesUnavailable,
                        backgroundColor: 'rgb(224, 224, 224, 0.8)',
                    }
                ]
            },
            options: {
                responsive: true,
                scales: {
                    x: {
                        type: 'time',
                        stacked: true,
                        offset: false,
                        time:{
                            unit: 'day',
                        },
                        ticks:{
                            autoSkip: true,
                            maxTicksLimit: isMobileRes() ? 5 : 10,
                            maxRotation: 0,
                            minRotation: 0,
                            //min: fromDate,//(new Date(fromDate.getTime())).setDate(fromDate.getDate() - 1),// Para que tenga offset por bug primera bar cortada
                            //max: tickVisibleMaxDate
                        },
                        grid: {
                            display: false
                        },
                        min: fromDate,
                        max: tickVisibleMaxDate
                    },
                    y: {
                        id: 'y',
                        offset: false,
                        ticks: {
                            beginAtZero: true,
                            maxTicksLimit: MAX_TICKS_LIMIT_Y,
                            stepSize: STEP_SIZE_Y,
                            callback: (label, index, labels)=>{
                                return formatPrice(label);
                            }
                        },
                        max: Math.ceil(chartMaxPrice / STEP_SIZE_Y) * STEP_SIZE_Y
                    }
                },
                plugins:{
                    legend: {
                        display: false
                    },
                    tooltip: {
                        enabled: true,
                        intersect: true,
                        mode: 'nearest',
                        position: 'nearest',
                        
                        displayColors: false,
                        backgroundColor: '#000000',
                        padding: {
                            x: 10,
                            y: 10
                        },
                                                                
                        titleAlign: 'center',
                        titleColor: '#8D8D8D',
                        titleFont: {
                            size: 14,
                            weight: 400,
                        },

                        bodyAlign: 'center',
                        bodyFont: {
                            size: 15,
                            weight: 550,
                        },
    
                        callbacks:{
                            title: (tooltipItems) => {
                                let itemData = tooltipItems[0].dataset.data[tooltipItems[0].dataIndex];
                                let date = itemData.x;
                                return dateToString(date, 'F j, Y');
                            },
                            label: (tooltipItem) => {
                                if(tooltipItem.datasetIndex == 0){
                                    let itemData = tooltipItem.dataset.data[tooltipItem.dataIndex];
                                    let price = itemData.y;
                                    return formatPrice(price);
                                }else{
                                    return 'Not available';
                                }
                                
                            }
                        }
                    },
                    zoom:{
                        pan:{
                            enabled: true,  
                            mode:'x',
                            speed: 10,
                            threshold: 1
                        },
                        zoom:{
                            mode: 'x',
                            wheel:{
                                enabled: true,
                            }                            
                        },
                        limits:{
                            x: {
                                min: fromDate,
                                max: toDate
                            }                            
                        }
                    }
                }
            }        
        });
        

        
    }

    _onResize(e){
        if(this._chart != null){
            let isMobile = isMobileRes();
        
            // Cambió a mobile
            if(!this._isMobileRes && isMobile){
                this._isMobileRes = true;
                
                this._chart.options.scales.xAxes[0].ticks.maxTicksLimit = 5
                this._chart.options.scales.yAxes[0].ticks.maxTicksLimit = 5
                this._chart.update();
            }

            // Cambió a desktop
            if(this._isMobileRes && !isMobile){
                this._isMobileRes = false;
                this._chart.options.scales.xAxes[0].ticks.maxTicksLimit = 10
                this._chart.options.scales.yAxes[0].ticks.maxTicksLimit = 8
                this._chart.update();

            }
        }
    }
}

export default BillboardDetailPriceChart;